import { Injectable, inject } from "@angular/core";
import { USER_GATEWAY } from "@app/app.providers";
import { UserEntity } from "@arch/domain/entity/user.entity";

@Injectable({
    providedIn: "root"
})
export class CheckTokenController {
    private readonly userGateway = inject(USER_GATEWAY);

    public async execute(
        input: string
    ): Promise<{ token: string; refreshToken: string; user: UserEntity }> {
        return await this.userGateway.checkToken(input);
    }
}
